module.exports = __webpack_public_path__ + "static/img/user-icon.22b906b7.svg";